import { useBreakpointValue, useMediaQuery } from '@chakra-ui/react';

/**
 * The emoji picker's desktop form (popover, search focused) needs a mouse
 * and room (M69, D263). An iPad (touch, wide) and a phone on its side (touch)
 * get the phone's panel and sheet, so no keyboard pops up over the emojis.
 */
export function useDesktopPicker(): boolean {
  const wide = useBreakpointValue({ base: false, md: true }) ?? false;
  const [fine] = useMediaQuery('(pointer: fine)', { ssr: false });
  return wide && Boolean(fine);
}
